import { Injectable } from "@angular/core";
import { ConstantService } from "../../core/services/constant.service";
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { catchError, map, Observable, throwError } from "rxjs";
import { InsuranceAcceptance } from "src/app/models/desgravamen/insurance-acceptance";
import { ApiBusResponse } from "src/app/shared/models/api-bus-response.model";

@Injectable({
  providedIn: "root",
})
export class InsuranceAcceptanceService {
  private insuranceAcceptanceURL = ConstantService.INSURANCE_ACCEPTANCE_URL;

  constructor(private http: HttpClient) {}

  getList(project_id): Observable<any> {
    return this.http
      .get<{}>(`${this.insuranceAcceptanceURL}?project_id=${project_id}&is_active=true`)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getListByProject_Credit_ID(
    project_id: string,
    identification_number: string,
    credit_number: string,
  ): Observable<any> {
    return this.http
      .get<{}>(`${this.insuranceAcceptanceURL}?project_id=${project_id}&identification_number=${identification_number}&credit_number=${credit_number}&is_active=true`)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getInsuranceAcceptance(params: any): Observable<any> {
    let httpParams = new HttpParams().set("credit_number", params);

    return this.http
      .get<any>(this.insuranceAcceptanceURL, { params: httpParams })
      .pipe(map((response) => response));
  }

  patch(data: any): Observable<any> {
    return this.http
      .patch<any>(`${this.insuranceAcceptanceURL}${data.id}`, data)
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  post(data: InsuranceAcceptance): Observable<any> {
    return this.http.post<any>(this.insuranceAcceptanceURL, data).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  deleteModule(id: string): Observable<any> {
    const url = `${this.insuranceAcceptanceURL}${id}`;
    return this.http.delete<any>(url).pipe(map((response) => response));
  }

  postAceptoSeguro(data: any): Observable<any> {
    return this.http
      .post<any>(this.insuranceAcceptanceURL + "acepto_seguro", data)
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  reSentNotificationDesgravamen(idInsurance: any): Observable<any> {
    return this.http.post<any>(
      this.insuranceAcceptanceURL +
        "reSentNotificationDesgravamen?idInsurance=" +
        idInsurance,
      null,
    );
  }

  acceptPendingInsurability(id: string, data: any = {}): Observable<any> {
    const formData = new FormData();
    formData.append("approvalBody", JSON.stringify(data));
    return this.http
      .post<any>(`${this.insuranceAcceptanceURL}${id}/approve-insurability/`, formData)
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }


  postAcceptance_model(data: any): Observable<any> {
    const {
      project_id,
      identificacion,
      numeroCredito,
      nameProduct,
      product_id,
      IdInstitucion,
      IdUsuario,
      plan_id,
      insurability_response_body,
      ...body
    } = data;

    const params = new HttpParams({
      fromObject: {
        project_id: String(project_id),
        identificacion: String(identificacion),
        numeroCredito: String(numeroCredito),
        nameProduct: String(nameProduct),
        product_id: String(product_id),
        IdUsuario: String(IdUsuario),
        IdInstitucion: String(IdInstitucion),
        plan_id: String(plan_id),
      },
    });

    const url = `${this.insuranceAcceptanceURL}acceptance_model/`;

    return this.http.post<any>(
      url,
      {
        ...body,
        ...(insurability_response_body ? { insurability_response_body } : {}),
      },
      { params },
    );
  }
}
